import { toDateInputValue } from "utils/evoTripsUi"

type Props = {
  value: unknown
  disabled?: boolean
  onChange: (isoDate: string) => void
}

export const EvoGroupDateCell = ({ value, disabled, onChange }: Props) => (
  <input
    type="date"
    disabled={disabled}
    value={toDateInputValue(value)}
    onChange={(e) => onChange(e.target.value)}
    className="text-xs border border-gray-200 rounded-lg px-2 py-1 bg-white min-w-[130px]"
  />
)
